// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as AboutRouteImport } from './routes/about'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as DomesticCleaningTidworthRouteImport } from './routes/domestic-cleaning-tidworth'
import { Route as JoinAsACleanerRouteImport } from './routes/join-as-a-cleaner'
import { Route as OfficeCleaningTidworthRouteImport } from './routes/office-cleaning-tidworth'
import { Route as OurWorkRouteImport } from './routes/our-work'
import { Route as PricingRouteImport } from './routes/pricing'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as QuoteRouteImport } from './routes/quote'
import { Route as ServiceAreasRouteImport } from './routes/service-areas'
import { Route as ServicesRouteImport } from './routes/services'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as ThankYouRouteImport } from './routes/thank-you'
import { Route as AuthenticatedAdminRouteImport } from './routes/_authenticated/admin'
import { Route as BookingTokenRouteImport } from './routes/booking.$token'
import { Route as ServicesIndexRouteImport } from './routes/services.index'
import { Route as ServicesAirbnbRouteImport } from './routes/services.airbnb'
import { Route as ServicesCommercialRouteImport } from './routes/services.commercial'
import { Route as ServicesDeepRouteImport } from './routes/services.deep'
import { Route as ServicesDomesticRouteImport } from './routes/services.domestic'
import { Route as ServicesEndOfTenancyRouteImport } from './routes/services.end-of-tenancy'
import { Route as ServicesMilitaryRouteImport } from './routes/services.military'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
            id: '/_authenticated',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const DomesticCleaningTidworthRoute = DomesticCleaningTidworthRouteImport.update({
            id: '/domestic-cleaning-tidworth',path: '/domestic-cleaning-tidworth',getParentRoute: () => rootRouteImport
          })
const JoinAsACleanerRoute = JoinAsACleanerRouteImport.update({
            id: '/join-as-a-cleaner',path: '/join-as-a-cleaner',getParentRoute: () => rootRouteImport
          })
const OfficeCleaningTidworthRoute = OfficeCleaningTidworthRouteImport.update({
            id: '/office-cleaning-tidworth',path: '/office-cleaning-tidworth',getParentRoute: () => rootRouteImport
          })
const OurWorkRoute = OurWorkRouteImport.update({
            id: '/our-work',path: '/our-work',getParentRoute: () => rootRouteImport
          })
const PricingRoute = PricingRouteImport.update({
            id: '/pricing',path: '/pricing',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const QuoteRoute = QuoteRouteImport.update({
            id: '/quote',path: '/quote',getParentRoute: () => rootRouteImport
          })
const ServiceAreasRoute = ServiceAreasRouteImport.update({
            id: '/service-areas',path: '/service-areas',getParentRoute: () => rootRouteImport
          })
const ServicesRoute = ServicesRouteImport.update({
            id: '/services',path: '/services',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const ThankYouRoute = ThankYouRouteImport.update({
            id: '/thank-you',path: '/thank-you',getParentRoute: () => rootRouteImport
          })
const AuthenticatedAdminRoute = AuthenticatedAdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => AuthenticatedRouteRoute
          })
const BookingTokenRoute = BookingTokenRouteImport.update({
            id: '/booking/$token',path: '/booking/$token',getParentRoute: () => rootRouteImport
          })
const ServicesIndexRoute = ServicesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => ServicesRoute
          })
const ServicesAirbnbRoute = ServicesAirbnbRouteImport.update({
            id: '/airbnb',path: '/airbnb',getParentRoute: () => ServicesRoute
          })
const ServicesCommercialRoute = ServicesCommercialRouteImport.update({
            id: '/commercial',path: '/commercial',getParentRoute: () => ServicesRoute
          })
const ServicesDeepRoute = ServicesDeepRouteImport.update({
            id: '/deep',path: '/deep',getParentRoute: () => ServicesRoute
          })
const ServicesDomesticRoute = ServicesDomesticRouteImport.update({
            id: '/domestic',path: '/domestic',getParentRoute: () => ServicesRoute
          })
const ServicesEndOfTenancyRoute = ServicesEndOfTenancyRouteImport.update({
            id: '/end-of-tenancy',path: '/end-of-tenancy',getParentRoute: () => ServicesRoute
          })
const ServicesMilitaryRoute = ServicesMilitaryRouteImport.update({
            id: '/military',path: '/military',getParentRoute: () => ServicesRoute
          })





const AuthenticatedRouteRouteChildren = {
  AuthenticatedAdminRoute: AuthenticatedAdminRoute
}

const AuthenticatedRouteRouteWithChildren = AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)




const ServicesRouteChildren = {
  ServicesAirbnbRoute: ServicesAirbnbRoute,ServicesCommercialRoute: ServicesCommercialRoute,ServicesDeepRoute: ServicesDeepRoute,ServicesDomesticRoute: ServicesDomesticRoute,ServicesEndOfTenancyRoute: ServicesEndOfTenancyRoute,ServicesMilitaryRoute: ServicesMilitaryRoute,ServicesIndexRoute: ServicesIndexRoute
}

const ServicesRouteWithChildren = ServicesRoute._addFileChildren(ServicesRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,AboutRoute: AboutRoute,AuthRoute: AuthRoute,ContactRoute: ContactRoute,DomesticCleaningTidworthRoute: DomesticCleaningTidworthRoute,JoinAsACleanerRoute: JoinAsACleanerRoute,OfficeCleaningTidworthRoute: OfficeCleaningTidworthRoute,OurWorkRoute: OurWorkRoute,PricingRoute: PricingRoute,PrivacyRoute: PrivacyRoute,QuoteRoute: QuoteRoute,ServiceAreasRoute: ServiceAreasRoute,ServicesRoute: ServicesRouteWithChildren,TermsRoute: TermsRoute,ThankYouRoute: ThankYouRoute,BookingTokenRoute: BookingTokenRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)